import React from "react";
import "./Sections.scss";
import inline4 from "../../assets/inline4.png";
function QA8() {
  return (
    <section className="interview">
      <div className="interview4">
        <div className="interview__inline4">
          <img className="mainSize" src={inline4} alt="" />
          <p className="caption interview8__caption">
            Carlo Coin, Roberto’s son and President of Factories and Vice
            President at Roberto Coin.
          </p>
        </div>
        <div className="interview__interview interview__interview4">
          <p className="interview__interview__title">
            Why is it so important that you always create something new?
          </p>
          <p className="interview__interview__copy">
            I don’t like standardization and I have always wanted my jewels to
            be unique. The design can be complicated, can be simple. You can
            make a prototype in two days, or it can take a month if it is
            complicated. Continuous innovation is essential, it means to go
            forward. And it is not only about jewels—it is about giving a future
            to culture.
          </p>
          <p className="interview__interview__copy">
            I am very fortunate to work with a team of maestros who understand
            my vision, and who are always innovating new ways to make my designs
            a reality. They are so capable here, it is incredible. Every person
            working in our factory is an extremely talented artisan. Their
            talent allows us to quickly change production and create new and
            innovative styles of jewelry.
          </p>
        </div>
      </div>
    </section>
  );
}

export default QA8;
